import { render } from "./Shifts.component.vue?vue&type=template&id=58331031"
import script from "./Shifts.component.vue?vue&type=script&lang=js"
export * from "./Shifts.component.vue?vue&type=script&lang=js"

import "./Shifts.component.vue?vue&type=style&index=0&id=58331031&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
